<template>
  <div class="location-contacts__contacts">
    <label class="location-contacts__contacts--label">{{ title }}</label>
    <ul
      class="contact-list"
      v-if="contacts.length"
    >
      <li
        class="contact"
        v-for="(item, index) in contacts"
        :key="index"
      >
        <div class="contact__name">
          <div class="contact-mail-to-name"><a
            :href="`mailto:${item.email}`"
            target="_top"
          >{{ item.name }}</a></div>
          <div class="contact-mail-to-tip">{{ item.email }}</div>
        </div>
        <div class="contact__title">{{ item.title }}</div>
      </li>
    </ul>
    <div v-else>--</div>
  </div>
</template>

<script>
export default {
  name: 'TenancyLocationContacts',
  props: {
    title: {
      type: String,
      required: true,
    },
    contacts: {
      type: Array,
      default () { return [] },
    },
  },
}
</script>

<style lang="scss" scoped>
.location-contacts__contacts {
  margin-bottom: 10px;
  & .contact-list {
    list-style:  none;
    margin-left: 0;
    & .contact {
      display: flex;
      justify-content: space-between;
      &__name {
        width: 40%;
        position: relative;
        display: inline-block;
        .contact-mail-to-tip {
          visibility: hidden;
          width: 200px;
          background-color: rgb(240, 240, 240);
          color: rgb(12, 58, 88);
          text-align: center;
          padding: 5px 0;
          border-radius: 6px;
          position: absolute;
          z-index: 1;
        }
        &:hover .contact-mail-to-tip {
          visibility: visible;
        }

      }
      &__title {
        width: 60%;
      }
      a {
        text-decoration: underline;
        color: #0c3a58;
      }
    }
  }
}

.location-contacts__contacts--label {
  font-size: 14px;
  margin-top: 0;
}
</style>
